export enum SERVICES_TYPES {
  CONFIGURATIONS = "CONFIGURATIONS",
  HTTP_CLIENT = "HTTP_CLIENT",
  STORAGE = "STORAGE",
  STORE = "STORE",
  AUTH = "AUTH",
  CHANNELS = "CHANNELS",
  WEBSOCKET = "WEBSOCKET",
  ORGANIZATION = "ORGANIZATION",
  LOGS = "LOGS",
  SUBSCRIPTION_HTTP_CLIENT = "SUBSCRIPTION_HTTP_CLIENT",
  SUBSCRIPTION_API = "SUBSCRIPTION_API",
  FEEDBACK = "FEEDBACK",
  SYSTEM_MESSAGES = "SYSTEM_MESSAGES",
  ORG_KPIS = "ORG_KPIS",
  PRICING = "PRICING",
  PACKAGES = "PACKAGES"
}
